// Merchant Order Actions Configuration
// Actions available to merchants for orders

import { 
  StarIcon
} from '@heroicons/react/24/outline';

export const merchantOrderActions = [
  // Review Customer (delivery_completed_to_customer) - appears when order has any delivered fulfillment groups
  {
    id: 'review_customer_order',
    label: 'Review Customer',
    type: 'primary',
    icon: StarIcon,
    conditions: {
      userRole: 'merchant',
      entityType: 'order',
      hasDeliveredFulfillmentGroups: true,
      noExistingCustomerReview: true
    },
    action: {
      type: 'redirect',
      target: '/order/{orderId}/customer/{customerId}/review'
    }
  },

  // Review Customer (pickup_completed_by_customer) - appears when order has completed pickup fulfillment groups
  {
    id: 'review_customer_pickup_order',
    label: 'Review Customer',
    type: 'primary',
    icon: StarIcon,
    conditions: {
      userRole: 'merchant',
      entityType: 'order',
      hasCompletedPickupFulfillmentGroups: true,
      noExistingCustomerReview: true
    },
    action: {
      type: 'redirect',
      target: '/order/{orderId}/customer/{customerId}/review'
    }
  },

  // Review Customer (partial_return_requested/group_return_requested) - appears when order has return requests
  {
    id: 'review_customer_returns_order',
    label: 'Review Customer',
    type: 'primary',
    icon: StarIcon,
    conditions: {
      userRole: 'merchant',
      entityType: 'order',
      hasReturnRequestedFulfillmentGroups: true,
      noExistingCustomerReview: true
    },
    action: {
      type: 'redirect',
      target: '/order/{orderId}/customer/{customerId}/review'
    }
  },

  // Review Customer (group_return_delivered) - appears when order has completed returns
  {
    id: 'review_customer_return_completed_order',
    label: 'Review Customer',
    type: 'primary',
    icon: StarIcon,
    conditions: {
      userRole: 'merchant',
      entityType: 'order',
      hasReturnCompletedFulfillmentGroups: true,
      noExistingCustomerReview: true
    },
    action: {
      type: 'redirect',
      target: '/order/{orderId}/customer/{customerId}/review'
    }
  }
]; 